<template lang="pug">
  .address-form
    validation-observer(v-slot="{ invalid }" ref="address")
      a.preview.address(v-if="active === false" href="#" @click.prevent.stop="activate")
        template(v-if="showCheckbox")
          .icon
            svg.add-icon(
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            )
              path(
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.3"
                d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              )
            .empty-checkbox
              .circle
          .data
            .field-preview
              .label(v-if="showLabel") {{ label }}
              .field-value
                p.text-gray-500 Neue {{ label }} hinzufügen
        template(v-else)
          .icon
            svg.default-icon(
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            )
              path(
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.3"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              )
              path(
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.3"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              )
            edit-icon
          .data
            .field-preview
              .label(v-if="showLabel") {{ label }}
              .field-value
                p.text-gray-500 {{ nameOneLiner }}
                p {{ addressOneLiner }}
      .preview.address(v-else)
        template(v-if="showCheckbox")
          .icon
            svg(
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            )
              path(
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.3"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              )
          .data
            .field-preview
              .label(v-if="showLabel") {{ label }}
              .field-value
                p Neue {{ label }}
        .details
          //- TODO
          //- add mapbox
          .form-fields
            template(v-if="showName")
              .trible-field
                .field(:style="{ 'max-width': '120px' }")
                  fieldset.form-field
                    label.label Anrede
                    multiselect(
                      v-model="gender"
                      :options="genders"
                      :multiple="false"
                      :searchable="false"
                      :allow-empty="true"
                      :show-labels="true"
                      track-by="value"
                      label="label"
                      :placeholder="salutation"
                      deselect-label=""
                      selected-label=""
                      select-label=""
                    )
                .field
                  fieldset.form-field
                    label.label(for="first_name") Vorname
                    .control.has-icons-right
                      input#first_name.input(
                        type="text"
                        name="first_name"
                        :placeholder="memberFirstName"
                        v-model="firstName"
                      )
                      span.icon
                        font-awesome-icon(icon="user")
                .field
                  fieldset.form-field
                    label.label(for="last_name") Nachname
                    .control.has-icons-right
                      input#last_name.input(
                        type="text"
                        name="last_name"
                        :placeholder="memberLastName"
                        v-model="lastName"
                      )
                      span.icon
                        font-awesome-icon(icon="user")
              //- .form-field
              //-   label.label(for="company") Firma
              //-   .control.has-icons-right
              //-     input#company.input(type="text" name="company" v-model="company")
              //-     span.icon
              //-       font-awesome-icon(icon="city")
              .double-field
                .field
                  fieldset.form-field
                    validation-provider(
                      name="E-Mail Adresse"
                      rules="email"
                      v-slot="{ errors }"
                    )
                      label.label(for="email") E-Mail Adresse
                      .control.has-icons-right
                        input#email.input(
                          type="email"
                          name="email"
                          :placeholder="memberEmail"
                          v-model="email"
                          :class="{ 'is-danger': errors && errors.length }"
                        )
                        span.icon
                          font-awesome-icon(icon="at")
                      p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                .field
                  fieldset.form-field
                    label.label(for="mobile") Mobilnummer
                    .control.has-icons-right
                      input#mobile.input(
                        type="tel"
                        name="mobile"
                        :placeholder="memberMobile"
                        v-model="mobile"
                      )
                      span.icon
                        font-awesome-icon(icon="phone")

              hr.mb-4

            fieldset.form-field
              validation-provider(name="Straße" rules="required" v-slot="{ errors }")
                label.label(for="street") Straße, Hausnummer
                .control.has-icons-right
                  input#street.input(
                    type="text"
                    name="street"
                    v-model="street"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="map-signs")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
            fieldset.form-field
              label.label(for="street-addition") Zusatz
              .control.has-icons-right
                input#street-addition.input(
                  type="text"
                  name="street-addition"
                  v-model="streetAddition"
                )
                span.icon
                  font-awesome-icon(icon="directions")

            .double-field
              .field(:style="{ 'max-width': '150px' }")
                fieldset.form-field
                  validation-provider(name="Postleitzahl" rules="required" v-slot="{ errors }")
                    label.label(for="zipcode") Postleitzahl
                    .control.has-icons-right
                      input#zipcode.input(
                        type="text"
                        name="zipcode"
                        v-model="zipcode"
                        :class="{ 'is-danger': errors && errors.length }"
                      )
                      span.icon
                        font-awesome-icon(icon="location-arrow")
                    p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                    p.help.has-text-grey(v-else) Pflichtfeld
              .field
                fieldset.form-field
                  validation-provider(name="Ort" rules="required" v-slot="{ errors }")
                    label.label(for="city") Ort
                    .control.has-icons-right
                      input#city.input(
                        type="text"
                        name="city"
                        v-model="city"
                        :class="{ 'is-danger': errors && errors.length }"
                      )
                      span.icon
                        font-awesome-icon(icon="city")
                    p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                    p.help.has-text-grey(v-else) Pflichtfeld

            fieldset
              select-with-validation.select-field(
                rules="required"
                name="Land"
                v-model="country"
                :options="countries"
                :multiple="false"
                :searchable="true"
                :loading="loadingCountries"
                :allow-empty="true"
                :show-labels="true"
                track-by="code"
                label="label"
                placeholder="suchen..."
                deselect-label="mit Enter abwählen"
                selected-label="ausgewählt"
                select-label="mit Enter auswählen"
                @search-change="findCountries"
              )
                template(v-slot:noOptions) Bitte machen Sie eine Eingabe, damit ein passender Ländername gefunden werden kann.
                template(v-slot:noResult) Es konnte kein passender Ländername gefunden werden.
</template>

<script>
import uniqid from 'uniqid';

import Fuse from 'fuse.js';
import { mapGetters, mapMutations } from 'vuex';

import Multiselect from 'vue-multiselect';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import { get, debounce, trim } from '@/helpers';

import SelectWithValidation from '@/components/Partials/SelectWithValidation';
import EditIcon from '@/extensions/restricted-area/components/UserForm/Partials/EditIcon';

import countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';
countries.registerLocale(de);

export default {
  name: 'AddressForm',
  props: {
    // form: {
    //   type: Object,
    //   required: true
    // },
    active: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'billing'
    },
    label: {
      type: String,
      default: 'Adresse'
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showName: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    genders: [
      {
        value: 'M',
        label: 'Herr'
      },
      {
        value: 'F',
        label: 'Frau'
      },
      {
        value: 'X',
        label: 'Sonstiges'
      }
    ],

    loadingCountries: false,
    countryOptions: Object.entries(countries.getNames('de')).map(el => ({ code: el[0], label: el[1] })),
    countries: [
      // must be searched async for performance reasons
      { code: 'DE', label: 'Deutschland' },
      { code: 'NL', label: 'Niederlande' },
      { code: 'FR', label: 'Frankreich' },
      { code: 'AU', label: 'Österreich' },
      { code: 'BE', label: 'Belgien' },
      { code: 'CH', label: 'Schweiz' },
      { code: 'LU', label: 'Luxemburg' }
    ]
  }),
  components: {
    EditIcon,
    ValidationProvider,
    ValidationObserver,
    SelectWithValidation,
    Multiselect
  },
  filters: {
    country(value) {
      return countries.getName(value, 'de');
    }
  },
  computed: {
    salutation() {
      let salutation = '';
      if (this.member.gender === 'M') salutation = 'Herr';
      else if (this.member.gender === 'F') salutation = 'Frau';
      return salutation;
    },

    memberFirstName() {
      if (this.isAuthenticated) return get(this.member, 'first_name', '');
      else return get(this.checkout.form.account, 'first_name', '');
    },
    memberLastName() {
      if (this.isAuthenticated) return get(this.member, 'last_name', '');
      else return get(this.checkout.form.account, 'last_name', '');
    },
    memberEmail() {
      if (this.isAuthenticated) return get(this.member, 'email', '');
      else return get(this.checkout.form.account, 'email', '');
    },
    memberMobile() {
      if (this.isAuthenticated) return get(this.member, 'mobile', '');
      else return get(this.checkout.form.account, 'mobile', '');
    },

    name() {
      let name = trim(`${this.salutation} ${this.memberFirstName} ${this.memberLastName}`);

      if (this.firstName || this.lastName) {
        let salutation = '';
        if (get(this.gender, 'value') === 'M') salutation = 'Herr';
        else if (get(this.gender, 'value') === 'F') salutation = 'Frau';
        name = trim(`${salutation} ${this.firstName} ${this.lastName}`);
      }

      return name;
    },
    // company() {
    //   let company = this.form.company;
    //   if (!company && this.address && this.address.company) company = this.address.company;
    //   return company;
    // },
    // companyAddition() {
    //   let companyAddition = this.form.company_addition;
    //   if (!companyAddition && this.address && this.address.company_addition) {
    //     companyAddition = this.address.company_addition;
    //   }
    //   return companyAddition;
    // },

    getterPathPart() {
      let path = 'account.billing_address';
      if (this.type === 'shipping') path = 'account.shipping_address';
      return path;
    },
    gender: {
      get() {
        return this.genders.find(el => el.value === get(this.checkout.form, `${this.getterPathPart}.gender`));
      },
      set(gender) {
        this.setField({ field: 'gender', value: gender.value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'gender', value: gender.value }, 'shipping');
      }
    },
    firstName: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.first_name`);
      },
      set(value) {
        this.setField({ field: 'first_name', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'first_name', value }, 'shipping');
      }
    },
    lastName: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.last_name`);
      },
      set(value) {
        this.setField({ field: 'last_name', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'last_name', value }, 'shipping');
      }
    },
    email: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.email`);
      },
      set(value) {
        this.setField({ field: 'email', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'email', value }, 'shipping');
      }
    },
    company: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.company`);
      },
      set(value) {
        this.setField({ field: 'company', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'company', value }, 'shipping');
      }
    },
    mobile: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.mobile`);
      },
      set(value) {
        this.setField({ field: 'mobile', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'mobile', value }, 'shipping');
      }
    },
    street: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.street`);
      },
      set(value) {
        this.setField({ field: 'street', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'street', value }, 'shipping');
      }
    },
    streetAddition: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.street_addition`);
      },
      set(value) {
        this.setField({ field: 'street_addition', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'street_addition', value }, 'shipping');
      }
    },
    zipcode: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.zipcode`);
      },
      set(value) {
        this.setField({ field: 'zipcode', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'zipcode', value }, 'shipping');
      }
    },
    city: {
      get() {
        return get(this.checkout.form, `${this.getterPathPart}.city`);
      },
      set(value) {
        this.setField({ field: 'city', value }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'city', value }, 'shipping');
      }
    },
    country: {
      get() {
        const code = get(this.checkout.form, `${this.getterPathPart}.country`);
        if (!code) return null;
        return {
          label: countries.getName(code, 'de'),
          code
        };
      },
      set(country) {
        const code = country?.code;
        this.setField({ field: 'country', value: code }, this.type);
        // if (this.type === 'billing' && ! this.addressOptions.billing.length)
        //   this.setField({ field: 'country', value: code }, 'shipping');
      }
    },
    nameOneLiner() {
      let name = trim(`${this.firstName} ${this.lastName}`, ', ');
      if (!name) name = trim(`${this.memberFirstName} ${this.memberLastName}`, ', ');
      return name;
    },
    addressOneLiner() {
      let country = '';
      if (this.country && this.country.label) country = this.country.label;
      return trim(`${this.street}, ${this.zipcode} ${this.city}, ${country}`, ', ');
    },
    ...mapGetters({
      member: 'auth/member',
      isAuthenticated: 'auth/isAuthenticated',
      addressOptions: 'shop/addressOptions',
      checkout: 'shop/checkout'
    })
  },
  methods: {
    activate() {
      const id = get(this.checkout.form, `${this.getterPathPart}.id`);
      if (id.startsWith('new:')) {
        // show form
        this.$emit('edit');
      } else {
        const data = {
          id: uniqid('new:'),
          gender: null,
          first_name: null,
          last_name: null,
          company: '',
          street: '',
          street_addition: '',
          zipcode: '',
          city: '',
          country: null,
          type: this.type,
          latitude: null,
          longitude: null
        };
        this.$emit('select', data);
      }
    },
    findCountries(query) {
      this.loadingCountries = true;
      this.debouncedFindCountries(query);
    },
    debouncedFindCountries: debounce(function(query) {
      // function scope is needed here
      if (query) {
        const settings = {
          shouldSort: true,
          tokenize: true,
          matchAllTokens: true,
          threshold: 0.3,
          minMatchCharLength: 1,
          keys: ['label']
        };
        const fuse = new Fuse(this.countryOptions, settings);
        this.countries = fuse.search(query).map(el => el.item);
      } else {
        this.resetCountries();
      }
      this.loadingCountries = false;
    }, 300),
    resetCountries() {
      this.countries = [
        { code: 'DE', label: 'Deutschland' },
        { code: 'NL', label: 'Niederlande' },
        { code: 'FR', label: 'Frankreich' },
        { code: 'AU', label: 'Österreich' },
        { code: 'BE', label: 'Belgien' },
        { code: 'CH', label: 'Schweiz' },
        { code: 'LU', label: 'Luxemburg' }
      ];
    },
    setField(payload, type) {
      if (type === 'shipping') this.setShippingField(payload);
      else this.setBillingField(payload);
    },
    ...mapMutations({
      setBillingField: 'shop/setCheckoutFormBillingAddressField',
      setShippingField: 'shop/setCheckoutFormShippingAddressField'
    })
  }
};
</script>

<style lang="sass" scoped>
.add-icon
  display: none
  padding: 0.3rem
.empty-checkbox
  @apply flex justify-center items-center
  width: 3rem
  height: 3rem
  .circle
    @apply border-2 border-gray-400
    width: 1.5rem
    height: 1.5rem
    border-radius: 50%

a.preview
  &:hover,
  &:active
    .add-icon
      display: block
    .empty-checkbox
      display: none
    .field-value p
      @apply text-black
</style>
